import Popup from "../../../../../../common/components/popup"
import ConfigurationDetails from "../components/setting-details"


export const CommerceBppSettingDetailPopup = ({ 
  item,
  closeModal,
  
}: any) => {

    return (
      <>
        <Popup onClose={closeModal}>
          <ConfigurationDetails onClose={closeModal} item={item}/>
        </Popup>
      </>
    )
  }